// RootData 部分项目（尤其是冷门/早期项目）的 tags 字段偶尔整组是纯中文类目名，
// 不同于 hot_index/get_fac 已核实稳定英文（300 条 project_cache 抽样：get_fac 恒为空，
// get_item 里 9/300 项目 tags 全中文，如 huobi → 中心化交易所/衍生品/公链）。
// Layer 1：已知字符串小词典（贴 earlyBirdTaxonomy.js ECOSYSTEM_CATEGORY_LABELS_EN 同款模式）；
// Layer 2：CJK 检测兜底——新出现、词典未覆盖的中文标签，英文界面下不裸露中文，
// 而是灰化+tooltip（单个 chip 场景）或从拼接列表中剔除（无法逐项 tooltip 的纯文本场景）。

const CJK_RE = /[一-鿿]/;

export const ROOTDATA_TAG_LABELS_EN = {
  '中心化交易所': 'Centralized Exchange',
  '衍生品': 'Derivatives',
  '公链': 'Public Chain',
  'AI/大模型': 'AI/LLM',
  '非Web3项目': 'Non-Web3 Project',
  '去中心化存储': 'Decentralized Storage',
  '内容检索': 'Content Retrieval',
  '开发者工具': 'Developer Tools',
  '基础设施': 'Infrastructure',
  'AI生成': 'AI-Generated',
  '图像生成': 'Image Generation',
  '创意工具': 'Creative Tools',
  '域名服务': 'Domain Service',
  '去中心化身份': 'Decentralized Identity',
  '合约自动化': 'Contract Automation',
  '链上管理': 'On-Chain Management',
  'DAO工具': 'DAO Tools',
  'DeFi基础设施': 'DeFi Infrastructure',
  '博彩/GameFi': 'Gambling/GameFi',
  'Counterparty协议': 'Counterparty Protocol',
  '比特币生态': 'Bitcoin Ecosystem',
  '去中心化计算': 'Decentralized Computing',
  'AI算力': 'AI Compute',
  'GPU市场': 'GPU Market',
  '模块化区块链': 'Modular Blockchain',
  'EVM兼容': 'EVM Compatible',
  '高性能公链': 'High-Performance Public Chain',
};

export const hasCJK = (str) => typeof str === 'string' && CJK_RE.test(str);

/**
 * 单个 tag 的展示用翻译（用于能逐项 tooltip 的 chip 场景，如 Pipeline Track 列）。
 * @returns {{ display: string, untranslated: boolean }} untranslated=true 表示英文界面下
 *   词典未覆盖、仍是中文，调用方应做灰化/tooltip 处理，而不是当作普通英文标签渲染。
 */
export function localizeRootDataTag(tag, lang) {
  if (lang !== 'en') return { display: tag, untranslated: false };
  const mapped = ROOTDATA_TAG_LABELS_EN[tag];
  if (mapped) return { display: mapped, untranslated: false };
  return { display: tag, untranslated: hasCJK(tag) };
}

/**
 * 批量翻译，用于拼接成纯文本展示的场景（evidence val / StatBlock，无法逐项 tooltip）。
 * 英文界面下：命中词典的翻译，词典未覆盖的中文原样剔除（而不是裸中文拼进英文句子）。
 * 中文界面下原样返回，不做任何过滤——中文原文本身就是可用数据。
 */
export function localizeRootDataTags(tags, lang) {
  if (!Array.isArray(tags)) return [];
  if (lang !== 'en') return tags;
  return tags
    .map((tg) => ROOTDATA_TAG_LABELS_EN[tg] || tg)
    .filter((tg) => !hasCJK(tg));
}
